import {
    IN_TREATMENT_STATUSES,
    PENDING_MONITORING_START_STATUS_ID,
    TREATMENT_IN_PROGRESS_STATUS_ID
} from '../work-queue/constants.ts';

// Moving on with only the open VAs is for a patient not yet in a VA step; in one, a new VA is needed.
const MOVE_ONLY_STATUSES: ReadonlySet<string> = new Set([
    PENDING_MONITORING_START_STATUS_ID,
    TREATMENT_IN_PROGRESS_STATUS_ID
]);

export const OPEN_NOW_TREATMENT_ONLY_HINT =
    'VAs can only be opened now in the Treatment phase; this one will be planned.';

export interface OpenNowScope {
    /** Mirrors the open-now route: outside Tx-0 to Tx-3, VAs can only be planned. */
    canOpenNow: boolean;
    /** Submitting with no new VAs moves the patient into the VA step. */
    allowMoveOnly: boolean;
}

export function openNowScopeFor(internalStatus: string | null): OpenNowScope {
    if (internalStatus === null) return { canOpenNow: false, allowMoveOnly: false };
    return {
        canOpenNow: IN_TREATMENT_STATUSES.has(internalStatus),
        allowMoveOnly: MOVE_ONLY_STATUSES.has(internalStatus)
    };
}
